export const pageData = [
  {
    title: "About",
    link: "/about/",
  },
  {
    title: "FAQs",
    link: "/faq/",
  },
  {
    title: "The ECZE Hub",
    link: "/hub/",
  },
  {
    title: "Get Started",
    link: "/getstarted/",
  },
]
